import styled from 'styled-components';

import { COLOR_GRAPH_NO_DATA } from '../../../globals';


export const StyledCharts = styled.div`
  .officestats-charts {
    padding: 10px 30px 10px 30px;
  }
  .officestats-charts-title {
    text-align: center;
    font-size: 1.325em;
  }

  .officestats-nodata {
    text-align: center;
    font-size: 1em;
    padding: 40px;
  }
  .officestats-nodata-icon {
    font-size: 2em;
    color: ${COLOR_GRAPH_NO_DATA};
  }
  .officestats-nodata-text {

  }
`;
